/* SPAGNOLO · Drawer de navegación
   Nivel 1 = pestañas · Nivel 2 = columna izquierda · Nivel 3 = columna derecha
   Lee el menú del admin. No hay ninguna categoría escrita a mano aquí. */
(function () {
  var drawer = document.querySelector('[data-sp-drawer]');
  if (!drawer) return;

  var panel = drawer.querySelector('.sp-drawer__panel');
  var lastFocus = null;

  /* Padres que apuntan a una hija suya: al pulsarlos en la cabecera
     abren el drawer en su pestaña en vez de navegar. Lo calcula el snippet. */
  var hijack = {};
  (drawer.getAttribute('data-sp-hijack') || '').split(';').forEach(function (par) {
    if (!par) return;
    var p = par.split('|');
    if (p.length === 2) hijack[p[0]] = p[1];
  });

  function isMobile() {
    return window.matchMedia('(max-width: 749px)').matches;
  }

  function activePane() {
    return drawer.querySelector('.sp-drawer__pane.is-active');
  }

  function clearSubs() {
    var pane = activePane();
    drawer.classList.remove('is-pushed');
    if (!pane) return;
    pane.querySelectorAll('.sp-drawer__sub').forEach(function (s) { s.hidden = true; });
    pane.querySelectorAll('.sp-drawer__item').forEach(function (i) { i.classList.remove('is-current'); });
  }

  function showSub(key) {
    var pane = activePane();
    if (!pane) return;
    var sub = pane.querySelector('[data-sp-sub="' + key + '"]');
    if (!sub || sub.hidden === false) {
      if (!sub) return;
    }
    clearSubs();
    sub.hidden = false;
    var btn = pane.querySelector('[data-sp-more="' + key + '"]');
    if (btn && btn.closest('.sp-drawer__item')) btn.closest('.sp-drawer__item').classList.add('is-current');
    if (isMobile()) drawer.classList.add('is-pushed');
  }

  function openFirstSub() {
    var pane = activePane();
    if (!pane) return;
    var first = pane.querySelector('.sp-drawer__sub');
    if (first) showSub(first.getAttribute('data-sp-sub'));
  }

  function reset() {
    clearSubs();
    if (!isMobile()) openFirstSub();
  }

  function selectTab(i) {
    drawer.querySelectorAll('[data-sp-tab]').forEach(function (t) {
      t.setAttribute('aria-selected', t.getAttribute('data-sp-tab') === i ? 'true' : 'false');
    });
    drawer.querySelectorAll('[data-sp-pane]').forEach(function (p) {
      p.classList.toggle('is-active', p.getAttribute('data-sp-pane') === i);
    });
    reset();
  }

  function openDrawer(tab) {
    lastFocus = document.activeElement;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('sp-noscroll');
    if (tab != null) { selectTab(tab); } else { reset(); }
    var c = panel && panel.querySelector('.sp-drawer__close');
    if (c) c.focus();
  }

  function closeDrawer() {
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('sp-noscroll');
    clearSubs();
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  /* Hamburguesa propia en escritorio. En móvil se reutiliza la del tema.
     El hueco lo reserva el CSS, así que insertarla no mueve el logo. */
  function injectBurger() {
    if (document.querySelector('.sp-burger')) return;
    var col = document.querySelector('.header__column--left') || document.querySelector('.header__columns');
    if (!col) return;
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'sp-burger';
    b.setAttribute('data-sp-open', '');
    b.setAttribute('aria-label', 'Abrir men\u00fa');
    b.innerHTML = '<svg width="20" height="14" viewBox="0 0 20 14" fill="none" aria-hidden="true"><path d="M0 1h20M0 7h20M0 13h20" stroke="currentColor" stroke-width="1.4"/></svg>';
    col.insertBefore(b, col.firstChild);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', injectBurger);
  } else {
    injectBurger();
  }
  document.addEventListener('shopify:section:load', injectBurger);

  var hg = document.querySelector('#header-group');
  if (hg && window.MutationObserver) {
    new MutationObserver(function () { injectBurger(); }).observe(hg, { childList: true, subtree: true });
  }

  /* Aperturas, en fase de captura para adelantarse al <details> de Horizon. */
  document.addEventListener(
    'click',
    function (e) {
      if (!e.target.closest) return;

      if (e.target.closest('[data-sp-open]')) {
        e.preventDefault();
        openDrawer();
        return;
      }

      var nativo = e.target.closest('.header__drawer summary, #Details-menu-drawer-container > summary');
      if (nativo) {
        e.preventDefault();
        e.stopPropagation();
        openDrawer();
        return;
      }

      var cabecera = e.target.closest('#header-component .menu-list__link');
      if (cabecera && cabecera.getAttribute) {
        var href = cabecera.getAttribute('href');
        if (href && hijack[href] !== undefined) {
          e.preventDefault();
          e.stopPropagation();
          openDrawer(hijack[href]);
        }
      }
    },
    true
  );

  drawer.addEventListener('click', function (e) {
    if (!e.target.closest) return;

    /* Móvil: toda la fila abre el submenú, no solo la flecha.
       Para ir a la categoría entera está el "Ver todo" de dentro. */
    if (isMobile()) {
      var fila = e.target.closest('.sp-drawer__row');
      if (fila) {
        var mas = fila.querySelector('[data-sp-more]');
        if (mas) {
          e.preventDefault();
          showSub(mas.getAttribute('data-sp-more'));
          return;
        }
      }
    }

    var el = e.target.closest('[data-sp-close],[data-sp-tab],[data-sp-more],[data-sp-back]');
    if (!el) return;
    if (el.hasAttribute('data-sp-close')) { e.preventDefault(); closeDrawer(); }
    else if (el.hasAttribute('data-sp-tab')) { selectTab(el.getAttribute('data-sp-tab')); }
    else if (el.hasAttribute('data-sp-more')) { e.preventDefault(); showSub(el.getAttribute('data-sp-more')); }
    else if (el.hasAttribute('data-sp-back')) { e.preventDefault(); clearSubs(); }
  });

  /* Escritorio: el hover abre el submenú desde cualquier punto de la fila,
     no solo desde la flecha. Delegado, así que cubre el ancho entero. */
  drawer.addEventListener('mouseover', function (e) {
    if (isMobile() || !e.target.closest) return;
    var item = e.target.closest('.sp-drawer__item');
    if (!item || item.classList.contains('is-current')) return;
    var mas = item.querySelector('[data-sp-more]');
    if (mas) showSub(mas.getAttribute('data-sp-more'));
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && drawer.classList.contains('is-open')) closeDrawer();
  });

  window.addEventListener('resize', function () {
    if (drawer.classList.contains('is-open')) reset();
  });
})();
